import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {RenderStrategy} from '../../enums/render-strategy';
import {RouteService} from '../route.service';
import {PointOfInterestService} from '../point-of-interest.service';
import {CategoryService} from '../category.service';
import {StoryService} from '../story.service';

export const routeDetailResolver: ResolveFn<Promise<[void, void, void, void]>> = (activatedRouteSnapshot) => {
  const slug = activatedRouteSnapshot.paramMap.get('slug') ?? '';
  return Promise.all([
    inject(CategoryService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(PointOfInterestService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(StoryService).resolveIndex(RenderStrategy.PREFER_SERVER),
    inject(RouteService).resolveBySlug(slug, RenderStrategy.PREFER_SERVER),
  ]);
};
